import {
  Button,
  Content,
  InputBox,
  Img,
  FileUploadButton,
  ContentLayout,
} from "@adminComponents";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {useAdminNav} from "@hook";
import {adminApi, utils} from "@utils";
import * as Datas from "@adminData";
import {AdminScreenId} from "@assets";

export default function Page() {
  const {navigate, getParams} = useAdminNav();
  const {no, sequnce} = getParams<{no?: number; sequnce?: number}>();
  const [detail, setDetail] = useState<Datas.IMemberResponse>({sequnce});

  const isEdit = !!detail.no;

  async function getDetail() {
    try {
      if (!no) {
        return;
      }

      const {data, success, message} = await adminApi.member.getDetail({no});
      if (success) {
        setDetail(data);
      } else {
        alert(message || "오류가 발생했습니다");
      }
    } catch (error) {
      console.error("getDetail error", error);
    }
  }

  async function write() {
    try {
      if (!detail.sequnce) {
        alert("기수를 입력해주세요.");
        throw Error("필수값 누락");
      }
      if (!detail.name) {
        alert("이름을 입력해주세요.");
        throw Error("필수값 누락");
      }
      const {success, data, message} = await adminApi.member.write(detail);
      if (success) {
        // navigate({
        //   url: AdminScreenId.MEMBER_DETAIL,
        //   params: {no: data?.no},
        // });
        navigate({
          url: AdminScreenId.MEMBER,
          params: {sequnce: detail.sequnce},
        });
      } else {
        alert(message);
      }
    } catch (error) {
      console.error("write error", error);
    }
  }

  async function edit() {
    try {
      if (!detail.no) {
        alert("오류");
        throw Error("필수값 누락");
      }
      if (!detail.sequnce) {
        alert("기수를 입력해주세요.");
        throw Error("필수값 누락");
      }
      if (!detail.name) {
        alert("이름을 입력해주세요.");
        throw Error("필수값 누락");
      }
      const {success, message} = await adminApi.member.edit(detail);
      if (success) {
        // getDetail();
        navigate({
          url: AdminScreenId.MEMBER,
          params: {sequnce: detail.sequnce},
        });
      } else {
        alert(message);
      }
    } catch (error) {
      console.error("edit error", error);
    }
  }

  async function deleteData() {
    try {
      if (!detail.no) {
        return;
      }
      if (!confirm("삭제하시겠습니까?")) {
        return;
      }
      const {success, message} = await adminApi.member.delete({
        no: detail.no,
      });
      alert(message);
      if (success) {
        navigate({
          url: AdminScreenId.MEMBER,
          params: {sequnce: detail.sequnce},
        });
      }
    } catch (error) {
      console.error("edit error", error);
    }
  }

  useEffect(() => {
    getDetail();
  }, [no]);

  return (
    <>
      <ContentLayout
        title="회원현황 상세"
        rightElement={
          <div className={styles.bottomSection}>
            {isEdit ? (
              <>
                <div>
                  <Button
                    backgroundColor="#d9d9d9"
                    fontSize={18}
                    paddingHorizontal={39}
                    paddingVertical={12}
                    text={"삭제"}
                    onClick={deleteData}
                  />
                </div>
                <div>
                  <Button
                    backgroundColor="#d9d9d9"
                    fontSize={18}
                    paddingHorizontal={39}
                    paddingVertical={12}
                    text={"수정"}
                    onClick={edit}
                  />
                </div>
              </>
            ) : (
              <>
                <div>
                  <Button
                    backgroundColor="#d9d9d9"
                    fontSize={18}
                    paddingHorizontal={39}
                    paddingVertical={12}
                    text={"등록"}
                    onClick={write}
                  />
                </div>
              </>
            )}
          </div>
        }>
        <Content>
          <div className={styles.content}>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                회원사진
                <br />
                <span>*가로 (199px) x 세로 (138px)</span>
              </div>
              <div className={[styles.col, styles.btn].join(" ")}>
                <FileUploadButton
                  text={"업로드"}
                  height={32}
                  width={32}
                  uploadUrl={"/api/v1/upload/member"}
                  fileUpload={data => {
                    const newFiles: Datas.IFiles[] = (data.files || [])
                      .slice(0, 1)
                      .map((item, index) => ({
                        url: item,
                        thumb_img_url: (data.thumbList || [])[index],
                      }));
                    setDetail?.({...detail, photo: newFiles});
                  }}
                />
              </div>
            </div>
            <div className={styles.imageContainer}>
              {(detail.photo || []).map(({url, thumb_img_url}, index) => {
                const imgUrl = thumb_img_url || url;
                return (
                  <div key={index} className={styles.imageContainer}>
                    <Img src={imgUrl} className={styles.img} />
                    <div className={styles.btnContainer}>
                      {index > 0 && (
                        <div
                          className={styles.item}
                          onClick={() => {
                            const newFiles = utils.moveArrayValue({
                              array: detail.photo || [],
                              fromIndex: index,
                              toIndex: index - 1,
                            });
                            setDetail?.({
                              ...detail,
                              photo: newFiles,
                            });
                          }}>
                          🔼
                        </div>
                      )}
                      <div
                        className={styles.item}
                        onClick={() => {
                          if (!confirm("이미지를 삭제하시겠습니까?")) {
                            return;
                          }
                          setDetail({
                            ...detail,
                            photo: (detail.photo || []).filter(
                              (temp, i) => i !== index,
                            ),
                          });
                        }}>
                        ❎
                      </div>
                      {index < (detail.photo || []).length - 1 && (
                        <div
                          className={styles.item}
                          onClick={() => {
                            const newImages = utils.moveArrayValue({
                              array: detail.photo || [],
                              fromIndex: index,
                              toIndex: index + 1,
                            });
                            setDetail({
                              ...detail,
                              photo: newImages,
                            });
                          }}>
                          🔽
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>기수</div>
              <div className={styles.col}>
                <InputBox
                  type="number"
                  value={detail?.sequnce}
                  onValue={value => {
                    setDetail({...detail, sequnce: Number(value)});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>이름</div>
              <div className={styles.col}>
                <InputBox
                  value={detail?.name}
                  onValue={value => {
                    setDetail({...detail, name: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>직책</div>
              <div className={styles.col}>
                <InputBox
                  value={detail?.position}
                  onValue={value => {
                    setDetail({...detail, position: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>연락처</div>
              <div className={styles.col}>
                <InputBox
                  value={detail?.tel}
                  onValue={value => {
                    setDetail({...detail, tel: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>코치</div>
              <div className={styles.col}>
                <InputBox
                  value={detail?.coach}
                  onValue={value => {
                    setDetail({...detail, coach: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>회사명</div>
              <div className={styles.col}>
                <InputBox
                  value={detail?.company}
                  onValue={value => {
                    setDetail({...detail, company: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                하는업무
              </div>
              <div className={styles.col}>
                <InputBox
                  value={detail?.company_work}
                  onValue={value => {
                    setDetail({...detail, company_work: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                회사주소
              </div>
              <div className={styles.col}>
                <InputBox
                  value={detail?.company_address}
                  onValue={value => {
                    setDetail({...detail, company_address: value});
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                상세페이지
                <br />
                <span>*이미지는 1장만 등록 됩니다.</span>
              </div>
              <div className={[styles.col, styles.btn].join(" ")}>
                <FileUploadButton
                  text={"업로드"}
                  height={32}
                  width={32}
                  uploadUrl={"/api/v1/upload/member"}
                  fileUpload={data => {
                    const newFiles: Datas.IFiles[] = (data.files || [])
                      .slice(0, 1)
                      .map((item, index) => ({
                        url: item,
                        thumb_img_url: (data.thumbList || [])[index],
                      }));
                    setDetail?.({
                      ...detail,
                      files: newFiles,
                    });
                  }}
                />
              </div>
            </div>
            <div className={styles.imageContainer}>
              {(detail.files || []).map(({url, thumb_img_url}, index) => {
                const imgUrl = thumb_img_url || url;
                return (
                  <div key={index} className={styles.imageContainer}>
                    <Img src={imgUrl} className={styles.img} />
                    <div className={styles.btnContainer}>
                      {index > 0 && (
                        <div
                          className={styles.item}
                          onClick={() => {
                            const newFiles = utils.moveArrayValue({
                              array: detail.files || [],
                              fromIndex: index,
                              toIndex: index - 1,
                            });
                            setDetail?.({
                              ...detail,
                              files: newFiles,
                            });
                          }}>
                          🔼
                        </div>
                      )}
                      <div
                        className={styles.item}
                        onClick={() => {
                          if (!confirm("이미지를 삭제하시겠습니까?")) {
                            return;
                          }
                          setDetail({
                            ...detail,
                            files: (detail.files || []).filter(
                              (temp, i) => i !== index,
                            ),
                          });
                        }}>
                        ❎
                      </div>
                      {index < (detail.files || []).length - 1 && (
                        <div
                          className={styles.item}
                          onClick={() => {
                            const newImages = utils.moveArrayValue({
                              array: detail.files || [],
                              fromIndex: index,
                              toIndex: index + 1,
                            });
                            setDetail({
                              ...detail,
                              files: newImages,
                            });
                          }}>
                          🔽
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Content>
      </ContentLayout>
    </>
  );
}
